// Matches floating point numbers with optional thousands separators
export const FLOATING_POINT_REGEX = /^[^0-9]*([0-9,]+)(?:\.([0-9]*))?$/

export const EMAIL_REGEX =
  /^(?![_.-])((?![_.-][_.-])[a-zA-Z+\d_.-]){0,63}[a-zA-Z+\d]@((?!-)((?!--)[a-zA-Z\d-]){0,63}[a-zA-Z\d]\.){1,2}([a-zA-Z]{2,14}\.)?[a-zA-Z]{2,14}$/g

export const TELEGRAM_USERNAME_REGEX = /^(@[a-z0-9_]{5,32}|[a-z0-9_]{5,32})$/

export const NUMBER_WITH_COMMAS_REGEX = "[0-9]{1,3}(,[0-9]{3})*(.[0-9]+)?"
